import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    beneficiaryFaqLink: 'Learn more about beneficial owners',
    description:
      'We are legally required to ask you for certain information about the company’s beneficiaries and shareholders:',
    infoLine1:
      'All individuals **holding shares** (Shareholders and/or beneficial owners)',
    infoLine2: 'All individuals with **voting rights**',
    infoLine3: 'All individual with a **top management role**',
    title: 'Add the beneficial owners and shareholders of the company',
  },
  fr: {
    beneficiaryFaqLink: 'En savoir plus à propos des bénéficiaires effectifs',
    description:
      'Nous sommes tenus légalement de vous demander certaines informations à propos des bénéficiaires et des actionnaires de l’entreprise\u00A0:',
    infoLine1:
      'Toute personne physique **possédant des parts** (Actionnaires et/ou bénéficiaires effectifs)',
    infoLine2: 'Toute personne physique ayant **un droit de vote**',
    infoLine3: 'Toute personne physique ayant **un rôle de direction**',
    title:
      'Ajoutez les bénéficiaires effectifs et actionnaires de l’entreprise',
  },
} as const);
